module.exports = __webpack_public_path__ + "static/media/user-add.bfde5f92.svg";